<div class="container py-5">
    <h2>Blog</h2>
    <p>Próximamente publicaremos noticias y artículos relacionados con SOSpect y la seguridad comunitaria.</p>
</div>